import React, { useEffect, useState } from "react";

import logoDev from "../../assets/images/png/logo.png";
import { BiSolidReport, BiUser } from "react-icons/bi";
import { BsChatLeft } from "react-icons/bs";
import { FaQuestionCircle, FaRegNewspaper } from "react-icons/fa";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { IoWifi } from "react-icons/io5";
import { ImExit, ImStatsDots } from "react-icons/im";
import { MdAppRegistration, MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import "./index.css";

export default function MenuLateral() {
  const [menuAbrir, setMenuAbrir] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [larguraTela, setLarguraTela] = useState(window.innerWidth);

  const menuItems = [
    {
      label: "Dashboards",
      icon: <ImStatsDots />,
      subItems: [
        { label: "Geral", path: "/dashboard/geral" },
        { label: "Pontuação", path: "/dashboard/pontuacao" }
      ]
    },
    {
      label: "Gestão",
      icon: <BiUser />,
      subItems: [
        { label: "Administradores", path: "/gestao-de-usuarios/administradores" },
        { label: "Participantes", path: "/gestao-de-usuarios/participantes" },
        { label: "Concessionárias", path: "/gestao-de-usuarios/concessionarias" },
        { label: "Veículos", path: "/gestao-de-usuarios/veiculos" }
      ]
    },
    {
      label: "Campanhas",
      icon: <MdAppRegistration />,
      subItems: [
        { label: "Gestão de Campanhas", path: "/campanhas/gestao-de-campanhas" },
        { label: "Importação", path: "/campanhas/importacao" },
        { label: "Validador de Apuração", path: "/campanhas/apuracao" },
        // { label: "Validador de apuração", path: "/campanhas/validador-apuracao" }
      ]
    },
    {
      label: "Acompanhamento",
      icon: <FaMagnifyingGlass />,
      subItems: [
        { label: "Performance", path: "/acompanhamento/performance" },
        // { label: "Ranking", path: "/acompanhamento/ranking" }, // oculto
        { label: "Novo Hyundai i20", path: "/acompanhamento/ranking-pre-venda" }
      ]
    },
    // Feed Hyundai oculto (mantido no código para reativar futuramente)
    // {
    //   label: "Feed Hyundai",
    //   icon: <IoWifi />,
    //   subItems: [
    //     { label: "Configuração de Ações", path: "/feedhyundai/configuracao-acoes" },
    //     { label: "Apuração", path: "/feedhyundai/apuracao" },
    //     { label: "Ranking", path: "/feedhyundai/ranking" }
    //   ]
    // },
    {
      label: "Comunicação",
      icon: <FaRegNewspaper />,
      subItems: [
        { label: "Notícias", path: "/comunicacao/noticia" },
        { label: "Banner", path: "/comunicacao/banner" },
        { label: "Como funciona", path: "/comunicacao/como-funciona" },
        { label: "Regulamento", path: "/comunicacao/regulamento" },
        { label: "Pop-up", path: "/comunicacao/pop-up" }
      ]
    },
    {
      label: "Fale Conosco",
      icon: <BsChatLeft />,
      subItems: [
        { label: "Chamado", path: "/fale-conosco/chamado" }
      ]
    }
  ];

  const singleItems = [
    { label: "FAQ", icon: <FaQuestionCircle />, path: "/faq" },
    { label: "Relatórios", icon: <BiSolidReport />, path: "/relatorios" },
    { label: "Sair", icon: <ImExit />, path: "/logout" }
  ];

  useEffect(() => {
    const handleResize = () => {
      setLarguraTela(window.innerWidth);
      setMenuAbrir(window.innerWidth < 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const navigate = useNavigate();

  return (
    <>
      <Sidebar
        collapsed={menuAbrir}
        style={{ height: "100vh" }}
        collapsedWidth="46px"
      >
        <div
          className="d-flex justify-content-end mt-2"
          onClick={() => setMenuAbrir(!menuAbrir)}
        >
          {menuAbrir ? (
            <MdOutlineKeyboardDoubleArrowRight />
          ) : (
            <MdOutlineKeyboardDoubleArrowLeft />
          )}
        </div>
        <Link to={"/home"} className="d-flex justify-content-center">
          <img
            src={logoDev}
            alt="logo"
            style={{ width: "50%", minWidth: 40 }}
          />
        </Link>
        
        <Menu>
          {menuItems.map((item, index) => (
            <SubMenu key={index} label={item.label} icon={item.icon}>
              {item.subItems.map((subItem, subIndex) => (
                <MenuItem
                  key={subIndex}
                  onClick={() => navigate(subItem.path)}
                >
                  {subItem.label}
                </MenuItem>
              ))}
            </SubMenu>
          ))}

          {singleItems.map((item, index) => (
            <MenuItem
              key={index}
              icon={item.icon}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </MenuItem>
          ))}
        </Menu>
      </Sidebar>
    </>
  );
}
